module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor11-ef35c3031be0fe08533dcab353ec5330.png";